function SavingsIcon() {
  return (
    <svg
      width="1em"
      height="1.5em"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7119 6.48004C11.5336 6.03337 11.2731 5.62671 10.9851 5.24004C10.8753 5.08671 10.7313 4.96004 10.5736 4.86004C10.0251 4.50004 9.46277 4.16004 8.92791 3.78004C8.72219 3.63337 8.51648 3.48671 8.35191 3.28671C8.07076 2.94671 8.15305 2.44004 8.52334 2.20004C8.57819 2.16671 8.59876 2.12671 8.59876 2.06671C8.59876 1.84004 8.46848 1.64671 8.24905 1.56671C7.94734 1.44671 7.39191 1.35337 6.85705 1.33337C6.32219 1.35337 5.76676 1.44671 5.45819 1.56671C5.23876 1.64671 5.10848 1.84004 5.10848 2.06004C5.10848 2.12004 5.13591 2.16004 5.18391 2.19337C5.55419 2.43337 5.63648 2.94004 5.35534 3.28004C5.19076 3.48004 4.98505 3.62671 4.77934 3.77337C4.25134 4.15337 3.68905 4.49337 3.14048 4.86004C2.98276 4.96671 2.83876 5.08671 2.72905 5.24004C2.44105 5.62671 2.18048 6.03337 2.00219 6.48004C1.84448 6.86004 1.78276 7.25337 1.85134 7.66671C1.90619 7.99337 1.98162 8.32004 2.06391 8.64004C2.24905 9.38671 2.52334 10.1 2.87305 10.7867C3.31191 11.6467 3.88105 12.4334 4.45705 13.2067C4.63534 13.4467 4.81362 13.6867 4.96448 13.94C4.98505 13.98 5.05362 14.0334 4.96448 14.0734C4.89591 14.1 4.84105 14.1334 4.84791 14.2067C4.85476 14.28 4.90962 14.32 4.97134 14.34C5.17019 14.3934 5.35534 14.4734 5.55419 14.52C5.87648 14.6 6.20562 14.6267 6.53476 14.6534C6.63762 14.66 6.74734 14.6667 6.85705 14.6667C6.96676 14.6667 7.07648 14.66 7.18619 14.6534C7.51534 14.6334 7.84448 14.6 8.16676 14.52C8.36562 14.4734 8.55076 14.3934 8.74962 14.34C8.81134 14.32 8.87305 14.28 8.87305 14.2067C8.87991 14.1334 8.82505 14.1 8.75648 14.0734C8.66048 14.04 8.73591 13.98 8.75648 13.94C8.90734 13.68 9.08562 13.4467 9.26391 13.2067C9.83991 12.4267 10.4091 11.6467 10.8479 10.7867C11.1976 10.1 11.4719 9.38671 11.6571 8.64004C11.7393 8.32004 11.8148 7.99337 11.8696 7.66671C11.9382 7.25337 11.8696 6.86004 11.7119 6.48004Z"
        stroke="black"
        strokeMiterlimit="10"
      />
      <path
        d="M5.26624 5.40665C5.26624 5.40665 6.94624 4.69999 8.45481 5.51332Z"
        fill="white"
      />
      <path
        d="M5.26624 5.40665C5.26624 5.40665 6.94624 4.69999 8.45481 5.51332"
        stroke="black"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default SavingsIcon;
